import classes from './TopBarNav.module.css';
import { NavLink } from 'react-router-dom';

type Item = {
  link: string;
  label: string;
  end?: boolean;
};

export type TopBarNavProps = {
  items: Array<Item>;
};
export const TopBarNav = ({ items }: TopBarNavProps) => {
  return (
    <nav className={classes.root}>
      <ul className={classes.items}>
        {items.map(({ label, link, end }) => (
          <li className={classes.item} key={label}>
            <NavLink
              to={link}
              end={end}
              className={({ isActive }) => {
                return isActive ? classes.active : classes.item;
              }}
            >
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
